import * as React from "react";
import {option} from "ts-option";
import FormGroup from "../../../hiberUiKit/src/molecules/FormGroup/FormGroup";
import {FormGroupProps} from "../../common/props/FormGroupProps";
import ItemQuantityPicker from "../quoteItemsPicker/ItemQuantityPicker";
import Amount from "../../../model/common/Amount";

interface ComponentProps {
	labourCost: number,
}

type Props = ComponentProps & FormGroupProps<number>;

const label = "Installation labour";

export default class LabourItemFormGroup extends React.Component<Props, {}> {

	render() {
		const price = new Amount(this.props.labourCost).multiple(this.props.field.value.getOrElse(0));
		return (
			<FormGroup label={"Labour costs"}>
				<ItemQuantityPicker key={label}
									name={label}
									price={price}
									quantity={this.props.field.value.getOrElse(0)}
									decrementLimit={0}
									onDecrementClick={() => this.onDecrementClick()}
									onIncrementClick={() => this.onIncrementClick()}/>
			</FormGroup>
		)
	}

	onDecrementClick() {
		if (this.props.field.value.getOrElse(0) - 1 >= 0) {
			this.updateValue(this.props.field.value.getOrElse(0) - 1);
		}
	}

	onIncrementClick() {
		this.updateValue(this.props.field.value.getOrElse(0) + 1);
	}


	updateValue(labourQuantity: number) {
		this.props.onChange(this.props.field.updateValue(option(labourQuantity)));
	}
}
